/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".change-password__actions[_ngcontent-%COMP%]{position:relative}.change-password__note[_ngcontent-%COMP%]{margin-top:25px;color:#413741;line-height:1.5}"];
export { styles as styles };
